/* eslint-disable max-len, react/no-unescaped-entities */
import React, { Component } from 'react';
import styled from 'styled-components';
import i18n from '../../config/i18n';

const H1 = styled.h1`
  color: #3C4F62;
  font-weight: 500;
  font-size: 3.2em;
  text-align: center;
  margin-top: 70px;
`;

const UpdatedText = styled.p`
  color: #B5C7D9;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 60px;
`;

const H3 = styled.h3`
  font-size: 1.8em;
  color: #748495;
  font-weight: 700;
  text-align: center;
  margin-top: 4em;
  margin-bottom: 2em;
`;

const P = styled.p`
  color: #73767c;
  line-height: 1.7;
  font-size: 16px;
  font-family: "Open Sans", Arial, sans-serif;
  text-align: justify;
`;

class PrivacyPolicy extends Component {
  genContent = (alias, length) => {
    const arr = [];
    for (let i = 1; i <= length; i += 1) {
      arr.push(
        <div key={alias + i}>
          <H3>{i18n.t(`${alias}_p${i}_h`)}</H3>
          <P>{i18n.t(`${alias}_p${i}`)}</P>
        </div>
      );
    }
    return arr;
  };

  render() {
    return (
      <div
        className="PrivacyPolicy"
        style={{ paddingBottom: 100 }}
      >
        <H1>
          {i18n.t('privacyPolicyTitle')}
        </H1>
        <UpdatedText>
          {i18n.t('privacyPolicyUpdateDate')}
        </UpdatedText>

        {this.genContent('privacyPolicyDetails', 11)}

      </div>
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/components/static/PrivacyPolicy.js